module.exports = __webpack_public_path__ + "c8f7febe8e128d51f87f1cced4e4a0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/d/d28.jpg
// module id = 530
// module chunks = 0